import type {
  DeliveryPartnerAccountType,
  DeliveryPartnerModalidade,
  DeliveryPartnerPixKeyType,
} from '@/types/delivery-partner';

/** Mirrors the API defaults so the form still renders if `form-options` is slow or unavailable. */
export const FALLBACK_REGIONS = [
  'Centro',
  'Zona Sul',
  'Zona Norte',
  'Zona Leste',
  'Zona Oeste',
  'Barueri',
  'Carapicuíba',
  'Diadema',
  'Guarulhos',
  'Não tenho preferência',
];

export const FALLBACK_WEEK_DAYS = [
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
  'Domingo',
];

export const FALLBACK_PERIODS = ['Manhã', 'Tarde', 'Noite', 'Madrugada'];

export const MODALIDADE_OPTIONS: Array<{
  value: DeliveryPartnerModalidade;
  label: string;
  hint: string;
}> = [
  {
    value: 'MEI',
    label: 'MEI',
    hint: 'Sou microempreendedor individual e emito nota fiscal.',
  },
  {
    value: 'RPA',
    label: 'RPA',
    hint: `Presto serviço como autônomo, via recibo de pagamento.

Ao escolher a modalidade RPA, você não precisa possuir um CNPJ. Realizaremos a emissão de recibo de pagamento autônomo para comprovar a prestação dos serviços. Com isso, você terá um desconto de 20,20%* no seu repasse quinzenal`,
  },
];

export const ACCOUNT_TYPE_OPTIONS: Array<{
  value: DeliveryPartnerAccountType;
  label: string;
}> = [
  { value: 'PF', label: 'Pessoa Física' },
  { value: 'PJ', label: 'Pessoa Jurídica' },
];

export const PIX_KEY_TYPE_OPTIONS: Array<{
  value: DeliveryPartnerPixKeyType;
  label: string;
}> = [
  { value: 'CPF', label: 'CPF' },
  { value: 'PHONE', label: 'Celular' },
  { value: 'EMAIL', label: 'E-mail' },
  { value: 'RANDOM', label: 'Chave aleatória' },
];

export const STEPS = [
  { id: 1, title: 'Dados pessoais' },
  { id: 2, title: 'Trabalho e pagamento' },
  { id: 3, title: 'Preferências' },
] as const;

export const MINIMUM_AGE = 18;
